/**
 * De-duplicate hits by `productId`, preserving first-occurrence order.
 *
 * The PLP grid accumulates pages on the client: Load More appends the next
 * page; Start From The Beginning prepends the earlier pages. Constructor.io
 * can return the same `productId` across page boundaries, so both flows funnel
 * their merged array through this before rendering — first occurrence wins, so
 * the merge order (append vs prepend) decides which copy survives. Hits with no
 * `productId` are always kept (there's nothing to key on).
 *
 * Extracted from `shop.$categoryId.tsx`'s `CategoryGridBody` to make the
 * accumulation dedupe independently unit-testable (SFCC-11207).
 */
export function dedupeByProductId<T extends { productId?: string }>(
  hits: T[],
): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const hit of hits) {
    const id = hit.productId;
    if (id) {
      if (seen.has(id)) continue;
      seen.add(id);
    }
    out.push(hit);
  }
  return out;
}
